var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1640_17517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 9.00004H3C2.45 9.00004 2 8.55004 2 8.00004C2 7.45004 2.45 7.00004 3 7.00004H6C6.55 7.00004 7 7.45004 7 8.00004C7 8.55004 6.55 9.00004 6 9.00004ZM6 12H3C2.45 12 2 12.45 2 13C2 13.55 2.45 14 3 14H6C6.55 14 7 13.55 7 13C7 12.45 6.55 12 6 12ZM19.88 18.29L16.76 15.17C15.9 15.73 14.87 16.05 13.76 15.99C11.39 15.88 9.36 14.03 9.04 11.68C8.6 8.33004 11.49 5.50004 14.87 6.07004C16.82 6.40004 18.44 7.92005 18.87 9.85004C19.2 11.31 18.88 12.67 18.17 13.75L21.3 16.88C21.69 17.27 21.69 17.9 21.3 18.29C20.91 18.68 20.27 18.68 19.88 18.29ZM17 11C17 9.35004 15.65 8.00004 14 8.00004C12.35 8.00004 11 9.35004 11 11C11 12.65 12.35 14 14 14C15.65 14 17 12.65 17 11ZM3 19H11C11.55 19 12 18.55 12 18C12 17.45 11.55 17 11 17H3C2.45 17 2 17.45 2 18C2 18.55 2.45 19 3 19Z",
    fill: "#6B7684"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1640_17517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableNoData);
export default __webpack_public_path__ + "static/media/TableNoData.2f0fc434e0ee25133cb5d1144e3dad9f.svg";
export { ForwardRef as ReactComponent };